module.exports = __webpack_public_path__ + "img/icon.91f44728.png";